// Shared off-screen capture host (2026-08-18, a11y review finding on the
// share-card web lift): both PostSessionSummaryCard mounts need to render the
// <ShareCardRenderer> off-screen (position:absolute, left:-10000 — laid out
// so ViewShot can capture it, invisible to sighted users) WITHOUT leaving it
// reachable to assistive tech. `accessibilityElementsHidden` alone (the prop
// mobile's hand-rolled version used) is iOS-only and react-native-web drops
// it silently — on web-rnw the whole off-screen card stayed IN the a11y
// tree, a real screen-reader trap (duplicate session summary read twice).
// `aria-hidden` is the one prop RN core translates correctly on every
// platform: View.js sets accessibilityElementsHidden (iOS) AND
// importantForAccessibility='no-hide-descendants' (Android) from it, and
// react-native-web maps it straight to the DOM aria-hidden attribute.
import type { ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';

export function OffscreenCapture({ children }: { children: ReactNode }) {
  return (
    <View style={styles.offscreen} pointerEvents="none" aria-hidden={true}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  offscreen: {
    position: 'absolute',
    left: -10000,
    top: 0,
  },
});
